import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  IconButton,
  MenuItem,
  Slide,
  Snackbar,
} from "@mui/material";
import { Alert } from "@mui/lab";
import { TransitionProps } from "@mui/material/transitions";
import { MoreHorizOutlined } from "@mui/icons-material";
import Menu from "@mui/material/Menu";
import CourseCreate from "./constructor/CourseCreate/CourseCreate";
import LessonEdit from "./lessons/LessonEdit";
import { courseService } from "../../../services/course.service";
import useSnackBar from "../../../hooks/useSnackBar";
import Link from "@mui/material/Link";
import { Modal } from "../../../shared/ui/Modal/Modal";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface Map {
  [key: string]: string | undefined;
}

const Courses = () => {
  const { setSnackBar } = useSnackBar();

  const [courses, setCourses] = React.useState<
    {
      status: string;
      name: string;
      id: string;
    }[]
  >([]);
  const [selectedCourse, setSelectedCourse] = React.useState<{
    id: string;
    name: string;
  }>();
  const [open, setOpen] = React.useState(false);
  const [openLessonEdit, setOpenLessonEdit] = React.useState(false);
  const [createSuccess, setCreateSuccess] = useState(false);
  const [archiveOpen, setArchiveOpen] = useState({ open: false, id: "" });

  const statuses: Map = {
    DRAFT: "Черновик",
    ARCHIVED: "В архиве",
    ACTIVE: "Активен",
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openMenu, setOpenMenu] = useState("");
  const handleClickMenu = (
    courseId: string,
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(courseId);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenu("");
  };

  const handleCloseSnackbar = () => {
    setCreateSuccess(false);
  };
  const handleClickOpen = () => {
    setSelectedCourse(undefined);
    setOpen(true);
  };
  const handleDeleteCourse = async () => {
    await courseService.deleteCourse(archiveOpen.id).then(() => {
      setSnackBar({
        title: "Курс архивирован",
        isActive: true,
        status: "success",
      });
    });
    await getCourses();
    setArchiveOpen({ open: false, id: "" });
  };

  const handleOpenArchiveModal = (id: string) => {
    setArchiveOpen({ open: true, id });
    handleCloseMenu();
  };

  const handleClose = (id: string) => {
    setOpen(false);
    if (id) setCreateSuccess(true);
  };
  const getStatus = (status: string) => {
    return statuses[status];
  };
  const getCourseStatusClass = (status: string) => {
    return status.toLowerCase();
  };

  const handleCloseLessonEdit = () => {
    setOpenLessonEdit(false);
  };
  const getCourses = useCallback(() => {
    courseService
      .getCourses()
      .then((data) => {
        if (Array.isArray(data.data)) setCourses(data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    getCourses();
  }, [getCourses]);

  return (
    <Box sx={{ margin: "32px", width: "100%" }}>
      <h3 className="courses-header">Курсы</h3>
      {courses.map((course, index) => (
        <div key={index} className="one-course">
          <div className="one-course-title">{course.name}</div>
          <div
            className={`one-course-status ${getCourseStatusClass(
              course.status
            )}`}>
            {getStatus(course.status)}
          </div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={openMenu === course.id ? "long-menu" : undefined}
            aria-expanded={openMenu === course.id ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleClickMenu.bind(this, course.id)}>
            <MoreHorizOutlined />
          </IconButton>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={openMenu === course.id}
            onClose={handleCloseMenu}>
            <MenuItem
              sx={{
                fontSize: "14px",
                fontWeight: 800,
                lineHeight: "20px",
              }}>
              <Link
                sx={{ textDecoration: "none" }}
                color="inherit"
                href={`/panel/constructor/${course.id}`}>
                Редактировать
              </Link>
            </MenuItem>
            <MenuItem
              sx={{
                fontSize: "14px",
                fontWeight: 800,
                lineHeight: "20px",
              }}
              className="course-menu-item"
              onClick={() => handleOpenArchiveModal(course.id)}>
              Архивировать
            </MenuItem>
            <MenuItem
              sx={{
                fontSize: "14px",
                fontWeight: 800,
                lineHeight: "20px",
              }}>
              <Link
                sx={{ textDecoration: "none" }}
                color="inherit"
                href={`/course/${course.id}`}>
                Перейти к курсу
              </Link>
            </MenuItem>
            <MenuItem
              sx={{
                fontSize: "14px",
                fontWeight: 800,
                lineHeight: "20px",
              }}>
              <Link
                sx={{ textDecoration: "none" }}
                color="inherit"
                href={`/course/learn/preview/${course.id}`}>
                Превью обучения
              </Link>
            </MenuItem>
          </Menu>
        </div>
      ))}
      {courses.length > 0 && (
        <Button variant="contained" onClick={handleClickOpen}>
          Создать новый
        </Button>
      )}
      {!courses.length && (
        <div className="empty-courses">
          <div className="empty-courses-title">Создайте первый курс</div>
          <div className="empty-courses-text">
            Вне зависимости от вашего опыта в преподавании вы можете сделать
            свой курс увлекательным.
          </div>
          <Button variant="contained" onClick={handleClickOpen}>
            Создать
          </Button>
        </div>
      )}

      <Modal
        isOpen={archiveOpen.open}
        onClose={() => setArchiveOpen({ open: false, id: "" })}>
        <div className={"archive-modal-wrp"}>
          <div className={"archive-modal-title"}> Архивировать курс?</div>

          <Box
            sx={{
              "@media (max-width: 1000px)": {
                display: "flex",
                flexDirection: "column",
                width: "100%",
              },
            }}>
            <Button
              onClick={() => {
                handleDeleteCourse();
              }}
              variant="outlined"
              sx={{
                marginRight: "15px",
                "@media (max-width: 1000px)": {
                  margin: "0 0 10px 0",
                  width: "100%",
                },
              }}>
              Да
            </Button>

            <Button
              onClick={() => setArchiveOpen({ open: false, id: "" })}
              variant="contained"
              sx={{
                "@media (max-width: 1000px)": {
                  width: "100%",
                },
              }}>
              Отмена
            </Button>
          </Box>
        </div>
      </Modal>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}>
        <CourseCreate close={handleClose} courseToEdit={selectedCourse} />
      </Dialog>

      <Dialog
        fullScreen
        open={openLessonEdit}
        onClose={handleCloseLessonEdit}
        TransitionComponent={Transition}>
        <LessonEdit close={handleCloseLessonEdit} courseId={selectedCourse} />
      </Dialog>
      <Snackbar
        open={createSuccess}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}>
          Курс успешно создан!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Courses;
